/* eslint max-len: ["error", 200] */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import UrlSearchParams from 'url-search-params'
import '../sign-up/sign-up.css'
import {
  UPDATE_PASSWORD_PENDING,
  CLEAR_PASSWORD_ERROR,
} from '../../actions'
import CONSTANTS from '../../constants/index'
import ErrorPopup from '../error-popup/error-popup'
import LoadingSvg from '../loading-svg'
import './gp-web-update-password.css';

export default class GpWebUpdatePassword extends Component {
  constructor(props) {
    super(props)

    this.state = {
      password: '',
      confirmPassword: '',
      validationError: '',
      uiPending: false,
      passwordUpdated: false,
    }
  }

  passwordHandler = (e) => {
    this.setState({
      password: e.target.value,
      validationError: '',
    })
  }

  confirmPasswordHandler = (e) => {
    this.setState({
      confirmPassword: e.target.value,
      validationError: '',
    })
  }

  updatePassword = (e) => {
    e.preventDefault()

    const { t } = this.props
    const { password, confirmPassword } = this.state

    if ((password.length < CONSTANTS.AUTH_MIN_PASSWORD_LENGTH) || (password.length > CONSTANTS.AUTH_MAX_PASSWORD_LENGTH)) {
      this.setState({
        validationError: t('ERROR_PASSWORD_LENGTH'),
      })
    } else if (password !== confirmPassword) {
      this.setState({
        validationError: t('ACCOUNT_PASSWORDS_VALIDATION'),
      })
    } else {
      this.setState({ uiPending: true })

      const urlParams = new UrlSearchParams(window.location.search)

      const data = {
        email: urlParams.get('email'),
        password: password,
        signature: urlParams.get('signature'),
      }

      this.props.handleAction(UPDATE_PASSWORD_PENDING, data)

      setTimeout(() => {
        this.setState({ passwordUpdated: true })
      }, 3000)
    }
  }

  passwordErrorHandler = () => {
    if (this.props.passwordError) {
      const { error } = this.props.passwordError

      if (error && error !== '' && typeof error === 'string') {
        setTimeout(() => this.props.handleAction(CLEAR_PASSWORD_ERROR), 30000)
        return error
      }
    }

    return ''
  }

  render() {
    const { t } = this.props
    const { validationError, uiPending, passwordUpdated } = this.state
    const passwordError = this.passwordErrorHandler()

    return (
      <div className="wrapper">

        <h1 className="title">{t('UPDATE_PASSWORD')}</h1>

        <div className="modal-content">

          <form className="forgot-email-dialog" onSubmit={this.updatePassword}>
            <input
              className={`recover-register xs-py3 text-input xs-text-7 xs-regular ${this.state.passwordError && 'error-input'}`}
              type="password"
              value={this.state.password}
              autoComplete="new-password"
              onChange={this.passwordHandler}
              placeholder={t('NEW_PASSWORD')}
            />
            <input
              className={`recover-register xs-py3 text-input xs-mb4 xs-text-7 xs-regular ${this.state.passwordError && 'error-input'}`}
              type="password"
              value={this.state.confirmPassword}
              autoComplete="new-password"
              onChange={this.confirmPasswordHandler}
              placeholder={t('REPEAT_PASSWORD')}
            />

            { validationError &&
              <p className="xs-mt1 xs-mb4 xs-text-red xs-text-left">{validationError}</p>
            }

            { passwordError &&
              <ErrorPopup t={t} error={passwordError} />
            }

            { passwordUpdated
              ? <span className="xs-text-center xs-px4 xs-block">{t('PASSWORD_UPDATE_SUCCESS')}</span>
              : <button
                type="submit"
                className={`button-primary xs-border-none xs-text-white xs-py3 xs-col-12 ${uiPending && 'disabled'}`}
              >
                {uiPending
                  ? <LoadingSvg />
                  : t('SEND_LINK')
                }
              </button>
            }
          </form>

        </div>
      </div>
    )
  }
}

GpWebUpdatePassword.propTypes = {
  handleAction: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  passwordError: PropTypes.string,
}

GpWebUpdatePassword.defaultProps = {
  passwordError: '',
}



// WEBPACK FOOTER //
// ./src/components/gp-web-update-password/gp-web-update-password.js